export default __webpack_public_path__ + "static/media/c5a8b73ef6a6c1147a1e573cc1cb1c96.png";